import { createContext, useState } from 'react';
import {Route, Routes} from 'react-router-dom';
import HallContractPayment from '@src/pages/weddingHall/HallContractPayment';
import HallInfo from '@src/pages/weddingHall/HallInfo';
import HallPrice from '@src/pages/weddingHall/HallPrice';
import HallReservation from '@src/pages/weddingHall/HallReservation';


interface PartnerIdContextType {
    partnerId: string;
    setPartnerId: React.Dispatch<React.SetStateAction<string>>;
    slotId: string;
    setSlotId: React.Dispatch<React.SetStateAction<string>>;
}
export const PartnerIdContext = createContext<PartnerIdContextType>({
    partnerId: '',
    setPartnerId: () => {},
    slotId: '',
    setSlotId: () => {},
});

const WeddinghallDetailRoutes = () => {
    const [partnerId, setPartnerId] = useState(); // partnerId context
    const [slotId, setSlotId] = useState(); // partnerId context
    
    return (
        <PartnerIdContext.Provider value={{partnerId, setPartnerId,slotId, setSlotId}}>
        <Routes>
            <Route path="/:uuid" element={<HallInfo />} />
            <Route path="/:uuid/slot" element={<HallPrice />} />
            <Route path="/:uuid/contract" element={<HallReservation />} />
            <Route path="/:uuid/contract/payment" element={<HallContractPayment />}/>
        </Routes>
        </PartnerIdContext.Provider>
    );
};

export default WeddinghallDetailRoutes;